import { IScraperJobConfigurationHistoryItem } from 'types/graphqlTypes'
import { useScraperJobConfigurationHistoryQuery } from '../graphql/ScraperJobConfigurationHistory'

interface IUseJobHistory {
  jobId: string
}

interface IJobHistory {
  jobHistory: IScraperJobConfigurationHistoryItem[]
  jobHistoryLoading: boolean
  refetchJobHistory: () => void
}

export const useJobHistory = ({ jobId }: IUseJobHistory) => {
  const { data, loading, refetch } = useScraperJobConfigurationHistoryQuery({
    variables: { jobUuid: jobId },
  })
  const { scraperJobConfigurationHistory } = data || {}

  const nodes: IScraperJobConfigurationHistoryItem[] =
    scraperJobConfigurationHistory?.scraperConfigurationHistory.map(
      job => job as IScraperJobConfigurationHistoryItem
    ) || []

  // Sort nodes by updatedAt in descending order
  nodes.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1))

  return {
    jobHistory: nodes,
    jobHistoryLoading: loading,
    refetchJobHistory: refetch,
  } as IJobHistory
}
